import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private storageService: StorageService) {}

  setClient(client: any) {
    this.storageService.addItem(client, "client");
  }

  getClient(): any {
    return this.storageService.getItem("client");
  }

  setCard(card: any) {
    this.storageService.addItem(card, "card");
  }

  getCard(): any {
    return this.storageService.getItem("card");
  }
}
